module.exports = __webpack_public_path__ + "img/082218_Laura Dicarlantonio_EC03.c0708695.jpg";